import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../utils/api';

const AdminAuditTab = () => {
  const [logs, setLogs] = useState([]);
  useEffect(() => { (async () => { try { const r = await adminAPI.getAuditLog(300); setLogs(r.data); } catch (e) {} })(); }, []);

  return (
    <div data-testid="admin-audit-tab">
      <div className="bg-white rounded-xl border border-gray-100 overflow-x-auto">
        <table className="w-full text-xs sm:text-sm">
          <thead className="bg-[#f8f9fa] text-left">
            <tr>
              <th className="px-3 py-2">When</th>
              <th className="px-3 py-2">Admin</th>
              <th className="px-3 py-2">Action</th>
              <th className="px-3 py-2 hidden sm:table-cell">Target</th>
              <th className="px-3 py-2 hidden md:table-cell">Meta</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.audit_id} className="border-t border-gray-100" data-testid={`audit-row-${l.audit_id}`}>
                <td className="px-3 py-2 text-[10px] text-[#6B7280] whitespace-nowrap">{(l.created_at || '').slice(0, 16).replace('T', ' ')}</td>
                <td className="px-3 py-2 text-[#0A0B10] font-bold truncate max-w-[160px]">{l.admin_name || l.admin_email || l.admin_user_id}</td>
                <td className="px-3 py-2"><code className="px-1.5 py-0.5 rounded bg-[#f0edff] text-[#1800ad] text-[10px]">{l.action}</code></td>
                <td className="px-3 py-2 hidden sm:table-cell text-[10px] text-[#6B7280]">{l.target_type}{l.target_id ? `:${l.target_id}` : ''}</td>
                <td className="px-3 py-2 hidden md:table-cell text-[10px] text-[#9CA3AF] truncate max-w-[260px]"><code>{JSON.stringify(l.meta || {})}</code></td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={5} className="px-3 py-8 text-center text-[#9CA3AF]">No audit entries yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAuditTab;
